"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityType = exports.RecentAnswerType = void 0;
var RecentAnswerType;
(function (RecentAnswerType) {
    RecentAnswerType["EMPLOYEE_SOLO"] = "EMPLOYEE_SOLO";
    RecentAnswerType["EMPLOYEE_ASSISTED"] = "EMPLOYEE_ASSISTED";
    RecentAnswerType["USER"] = "USER";
    RecentAnswerType["ORIGINATOR"] = "ORGINATOR";
})(RecentAnswerType || (exports.RecentAnswerType = RecentAnswerType = {}));
var IdentityType;
(function (IdentityType) {
    IdentityType["PERSONA"] = "PERSONA";
    IdentityType["EMPLOYEE"] = "EMPLOYEE";
    IdentityType["NONE"] = "NONE";
})(IdentityType || (exports.IdentityType = IdentityType = {}));
